/* eslint-disable object-curly-spacing */ 
/* eslint-disable no-undef */ 
/* eslint-disable own-handles */ 
/* eslint-disable no-innerhtml-assign */ 
/* eslint-disable consistent-method-names */ 
/* eslint-disable no-jsdoc */ 
define([
    'leaflet',
    './mapUtils'
],
function(
    L,
    mapUtils
) {

    function pushToUpdatedLayers(alreadyUpdatedLayers, layer, options) {
        if (layer) {
            layer.updateOptions(options);
            alreadyUpdatedLayers.push(layer);
        }
    }

    function getTrafficLayersToSeekFor(options) {
        var layersToSeek = [];
        if (options.traffic) {
            layersToSeek.push('traffic', 'trafficIncidents', 'trafficWithIncidents');
        }

        if (options.trafficFlow) {
            layersToSeek.push('trafficFlow');
        }
        return layersToSeek;
    }

    function updateTrafficLayer(alreadyUpdatedLayers, layer, options) {
        if (layer.name === 'trafficFlow') {
            pushToUpdatedLayers(alreadyUpdatedLayers, layer, options.trafficFlow);
        } else {
            //updates if layers.name equals traffic, trafficIncidents, trafficWithIncidents
            pushToUpdatedLayers(alreadyUpdatedLayers, layer, options.traffic);
        }
    }

    function updateTrafficLayers(alreadyUpdatedLayers, options) {
        var that = this;
        var layersToSeek = getTrafficLayersToSeekFor(options);
        layersToSeek.forEach(function(layerName) {
            var layer = mapUtils.findLayersByName(layerName, that)[0];
            if (layer) {
                updateTrafficLayer(alreadyUpdatedLayers, layer, options);
            }
        });
    }

    /**
     * Updates options added currently to map (including inactive base layers).
     * Only the update of the options `style` and `layer` are supported.
     *
     * Also allows to update refresh rate option of traffic layers.
     *
     * @method updateLayersOptions
     * @param {Object} options Options to be updated
     * @param {"main"|"night"} [options.style] The new base map style to use.
     *     By default, the current style is used (i.e. no update of this property).
     * @param {"basic"|"hybrid"|"labels"} [options.layer] The new base map layer to use.
     *     By default, the current layer is used (i.e. no update of this property).
     * @param {Object|Boolean} options.traffic Options used to change refresh rate.
     * Please note that minimal refresh rate is 30000 ms, if you provide lower value it will be defaulted to 30000 ms.
     * @param {Object} options.trafficFlow Options used to change refresh rate.
     * Please note that minimal refresh rate is 30000 ms, if you provide lower value it will be defaulted to 30000 ms.
     */
    L.Map.prototype.updateLayersOptions = function(options) {
        var alreadyUpdatedLayers = [];
        pushToUpdatedLayers(alreadyUpdatedLayers, this._ttBaseLayers.raster, options);
        pushToUpdatedLayers(alreadyUpdatedLayers, this._ttBaseLayers.vector, options);
        pushToUpdatedLayers(alreadyUpdatedLayers, this._ttLabelsLayers.vector, options);
        pushToUpdatedLayers(alreadyUpdatedLayers, this._ttLabelsLayers.raster, options);
        updateTrafficLayers.call(this, alreadyUpdatedLayers, options);
        L.Util.setOptions(this, options);

        this.eachLayer(function(layer) {
            if (layer.updateOptions && alreadyUpdatedLayers.indexOf(layer) === -1) {
                layer.updateOptions(options);
            }
        });
    };
});



// WEBPACK FOOTER //
// ./display/layerOptionsUpdater.js